import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { pick } from 'lodash-es';

import { CustomQuickorderState } from './custom-quickorder-store';
import { QuickOrderEffects } from './quick-order/quick-order.effects';
import { quickOrderReducer } from './quick-order/quick-order.reducer';

const customQuickorderReducers: ActionReducerMap<CustomQuickorderState> = { quickOrder: quickOrderReducer };

const customQuickorderEffects = [QuickOrderEffects];

@NgModule({
  imports: [
    EffectsModule.forFeature(customQuickorderEffects),
    StoreModule.forFeature('customQuickorder', customQuickorderReducers),
  ],
})
export class CustomQuickorderStoreModule {
  static forTesting(...reducers: (keyof ActionReducerMap<CustomQuickorderState>)[]) {
    return StoreModule.forFeature('customQuickorder', pick(customQuickorderReducers, reducers));
  }
}
